module.exports = __webpack_public_path__ + "static/media/baby-boy.276ef450.svg";